import { useCallback, useEffect, useState } from "react";
import { usePanel } from "./PanelLayout";
import { OrderTable } from "@/components/staff/OrderTable";
import { OrderDetailDialog } from "@/components/staff/OrderDetailDialog";
import { useOrderActions } from "@/lib/useOrderActions";

const TABS = [
  { key: "", label: "Semua", c: "semua" },
  { key: "baharu", label: "Baharu", c: "baharu" },
  { key: "proses", label: "Sedang Proses", c: "proses" },
  { key: "selesai", label: "Selesai", c: "selesai" },
  { key: "batal", label: "Dibatalkan", c: "batal" },
];

export default function Orders() {
  const { req, tick, refreshCount } = usePanel();
  const [tab, setTab] = useState("baharu");
  const [data, setData] = useState({ orders: [], counts: {} });
  const [selected, setSelected] = useState(null);

  const load = useCallback(() => {
    req("get", `/staff/orders${tab ? `?status=${tab}` : ""}`).then((d) => {
      setData(d);
      setSelected((s) => (s ? d.orders.find((o) => o.id === s.id) || s : s));
    });
    refreshCount();
  }, [req, tab, refreshCount]);
  useEffect(() => { load(); }, [load, tick]);
  const act = useOrderActions(req, load, setSelected);

  return (
    <div className="rise">
      <h2 className="font-display text-2xl font-bold mb-5">Senarai Pesanan</h2>
      <div className="flex flex-wrap gap-2 mb-5" data-testid="order-tabs">
        {TABS.map((t) => (
          <button key={t.c} onClick={() => setTab(t.key)} data-testid={`tab-${t.c}`}
            className={`px-4 h-9 rounded-full text-sm font-medium border transition-colors ${tab === t.key ? "bg-[#B91C1C] text-white border-[#B91C1C]" : "bg-white hover:border-[#B91C1C]"}`}>
            {t.label} ({data.counts[t.c] ?? 0})
          </button>
        ))}
      </div>
      <div className="bg-white rounded-2xl border p-4 md:p-6">
        <OrderTable orders={data.orders} onAction={act} onOpen={setSelected} />
      </div>
      <OrderDetailDialog order={selected} onClose={() => setSelected(null)} onAction={act} />
    </div>
  );
}
